<template>
  <div class="con9">
    <div class="container">
      <p class="text-title">
        에듀테크 선도기업<br />
        캐럿의<br class="br-pc" />
        <span>말랑톡</span>
      </p>
      <div class="list-wrapper">
        <ul class="list">
          <li class="item">
            <p>1위</p>
            <p>글로벌 교육 No.1</p>
            <p>
              2021년 기준 1,500개 기업 대상<br class="br-m" />
              어학교육 진행 中
            </p>
          </li>
          <li class="item">
            <p>21년</p>
            <p>외국어 교육 부분의 21년 R&D역량</p>
            <p>
              8만개 이상의 컨텐츠와<br class="br-m" />
              1,200여종의 단행본, 강의 제작
            </p>
          </li>
          <li class="item">
            <p>350,000+</p>
            <p>연간 35만명 이상의 어학교육 진행</p>
          </li>
          <li class="item">
            <p>3,000+</p>
            <p>15개 언어, 3,000명 이상의 강사진</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 46px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 170px;
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.br-pc {
  display: none;

  @media screen and (min-width: 1200px) {
    display: block;
  }
}

.con9 {
  padding: 86px 0;

  @media screen and (min-width: 1200px) {
    padding: 174px 0;
  }

  .text-title {
    font-size: 30px;
    font-weight: 700;
    color: #18181b;
    text-align: center;

    span {
      color: #8b5cf6;
      padding-left: 4px;
    }

    @media screen and (min-width: 1200px) {
      font-size: 52px;
      text-align: left;

      span {
        font-size: 62px;
        display: inline-block;
        padding-left: 0;
        padding-top: 16px;
      }
    }
  }

  .list-wrapper {
    padding-left: 24px;
    border-left: 1px solid #b6bac3;

    @media screen and (min-width: 1200px) {
      padding-left: 34px;
    }

    .list {
      display: flex;
      flex-direction: column;
      gap: 38px;
      padding: 14px 0;

      @media screen and (min-width: 1200px) {
        gap: 72px;
        padding: 22px 0;
      }

      .item {
        position: relative;

        &::before {
          content: "";
          width: 14px;
          height: 14px;
          background: #8b5cf6;
          border-radius: 100%;
          position: absolute;
          top: 12px;
          left: -32px;

          @media screen and (min-width: 1200px) {
            width: 22px;
            height: 22px;
            top: 16px;
            left: -46px;
          }
        }

        p {
          color: #18181b;

          &:nth-of-type(1) {
            font-size: 32px;
            font-weight: 700;

            @media screen and (min-width: 1200px) {
              font-size: 48px;
            }
          }

          &:nth-of-type(2) {
            font-size: 18px;
            font-weight: 700;
            padding-top: 14px;

            @media screen and (min-width: 1200px) {
              font-size: 26px;
              padding-top: 10px;
            }
          }

          &:nth-of-type(3) {
            font-size: 15px;
            padding-top: 8px;

            @media screen and (min-width: 1200px) {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}
</style>
